import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Home,
  AlertCircle,
  ArrowLeft,
  Search,
  FileText,
  Flower2,
  HelpCircle,
} from 'lucide-react';
import Button from '../components/common/Button';

const QUICK_LINKS = [
  { to: '/obituaries', label: '부고 찾기', icon: FileText },
  { to: '/wreaths', label: '화환 보내기', icon: Flower2 },
  { to: '/support', label: '고객 지원', icon: HelpCircle },
  { to: '/', label: '홈', icon: Home },
];

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    const q = query.trim();
    if (!q) return;
    // 부고 검색 페이지로 쿼리 전달
    navigate(`/obituaries/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory px-4 py-12">
      <div className="text-center max-w-lg w-full">
        {/* 404 아이콘 */}
        <div className="mb-8">
          <AlertCircle size={80} className="mx-auto text-gray-400" aria-hidden="true" />
        </div>

        {/* 404 텍스트 */}
        <h1 className="text-6xl font-bold text-charcoal mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          페이지를 찾을 수 없습니다
        </h2>
        <p className="text-gray-600 mb-8">
          요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다.
          <br />
          주소를 다시 확인하거나 아래에서 원하는 페이지를 찾아보세요.
        </p>

        {/* 검색창 */}
        <form onSubmit={handleSearch} className="mb-8" role="search">
          <div className="flex gap-2">
            <div className="relative flex-1">
              <Search
                size={18}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                aria-hidden="true"
              />
              <input
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="부고 검색 (고인명/장례식장)"
                aria-label="부고 검색"
                className="w-full rounded-lg border border-accent-300 bg-white py-2 pl-10 pr-4 text-primary placeholder-accent-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
            </div>
            <Button type="submit" variant="primary">
              검색
            </Button>
          </div>
        </form>

        {/* 주요 메뉴 바로가기 (사이트맵) */}
        <div className="mb-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {QUICK_LINKS.map(({ to, label, icon: Icon }) => (
            <Link
              key={to}
              to={to}
              className="flex flex-col items-center gap-2 rounded-lg border border-accent-200 bg-white px-3 py-4 text-sm font-medium text-charcoal transition-colors hover:bg-primary-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
            >
              <Icon size={22} className="text-primary-700" aria-hidden="true" />
              {label}
            </Link>
          ))}
        </div>

        {/* 이전 페이지 / 홈으로 */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center gap-2"
          >
            <ArrowLeft size={20} />
            <span>이전 페이지로</span>
          </Button>
          <Link to="/">
            <Button variant="primary" className="inline-flex items-center justify-center gap-2 w-full sm:w-auto">
              <Home size={20} />
              <span>홈으로 돌아가기</span>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
